import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {AuthState} from '../states/auth/auth.state';
import {Router} from '@angular/router';

export enum ErrorStatusesEnum {
  InternalServerError = 500,
  NotFound = 404,
  Unauthorized = 401,
  Integration = 400,
  AccountUnderReview = 450
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   const idToken: string = this.store.selectSnapshot(AuthState.accessToken);

   const cloneOptions: any = {
      withCredentials: true //this will pick up the hardened cookies and send to the server
    };

    if (idToken) {
      cloneOptions.setHeaders = {
        Authorization: `Bearer ${idToken}`
      };
    }
    const authReq = req.clone(cloneOptions);

    return next.handle(authReq);
  }
}
